var map = {
	"./1.gif": "3f56",
	"./10.gif": "df65",
	"./14.gif": "6916",
	"./15.gif": "d9bd",
	"./18.gif": "8176e",
	"./20.gif": "bc2f",
	"./3.gif": "4fdd",
	"./4.gif": "0d74",
	"./5.gif": "f455",
	"./6.gif": "fc39",
	"./7.gif": "ec7f",
	"./8.gif": "907a",
	"./9.gif": "b37d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "04c5";